
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function WallOfFame() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBookClass = () => {
    // Trigger Readdy Agent widget for booking
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    } else {
      // Fallback to contact page
      navigate('/contact');
    }
  };

  const achievements = [
    {
      name: t('wallOfFame.students.alexandra') || 'Alexandra Petrenko',
      subject: t('courses.mathematics'),
      achievement: t('wallOfFame.achievements.mathOlympiad') || 'Mathematics Olympiad Winner',
      score: '98/100',
      image: 'https://readdy.ai/api/search-image?query=Happy%20teenage%20girl%20student%20celebrating%20academic%20success%2C%20bright%20smile%2C%20holding%20academic%20award%2C%20educational%20achievement%2C%20professional%20portrait%2C%20inspiring%20success%20story%2C%20bright%20educational%20background%20with%20emerald%20and%20teal%20accents&width=300&height=300&seq=student-1-v3&orientation=squarish'
    },
    {
      name: t('wallOfFame.students.maxim') || 'Maxim Kovalenko',
      subject: t('courses.english'),
      achievement: t('wallOfFame.achievements.ielts') || 'IELTS 8.5 Score',
      score: 'IELTS 8.5',
      image: 'https://readdy.ai/api/search-image?query=Confident%20teenage%20boy%20student%20with%20academic%20achievement%2C%20proud%20expression%2C%20holding%20English%20certificate%2C%20educational%20success%2C%20professional%20headshot%2C%20bright%20educational%20background%20with%20emerald%20and%20teal%20accents&width=300&height=300&seq=student-2-v2&orientation=squarish'
    },
    {
      name: t('wallOfFame.students.anna') || 'Anna Sydorenko',
      subject: t('courses.mathematics'),
      achievement: t('wallOfFame.achievements.university') || 'Prestigious University Admission',
      score: '195/200',
      image: 'https://readdy.ai/api/search-image?query=Young%20female%20student%20celebrating%20university%20admission%2C%20joyful%20expression%2C%20academic%20success%2C%20bright%20educational%20background%2C%20inspiring%20achievement%20portrait%2C%20emerald%20and%20teal%20color%20scheme&width=300&height=300&seq=student-3-v2&orientation=squarish'
    },
    {
      name: t('wallOfFame.students.dmytro') || 'Dmytro Ivanenko',
      subject: t('courses.english'),
      achievement: t('wallOfFame.achievements.cambridge') || 'Cambridge Certificate',
      score: 'Grade A',
      image: 'https://readdy.ai/api/search-image?query=Teenage%20male%20student%20with%20Cambridge%20certificate%2C%20confident%20smile%2C%20academic%20achievement%2C%20professional%20educational%20portrait%2C%20success%20story%2C%20bright%20background%20with%20educational%20elements&width=300&height=300&seq=student-4-v2&orientation=squarish'
    },
    {
      name: t('wallOfFame.students.sofia') || 'Sofia Melnyk',
      subject: t('courses.mathematics'),
      achievement: t('wallOfFame.achievements.international') || 'International Olympiad',
      score: '96/100',
      image: 'https://readdy.ai/api/search-image?query=Young%20girl%20student%20with%20international%20mathematics%20award%2C%20proud%20achievement%2C%20holding%20medal%2C%20bright%20educational%20setting%2C%20inspiring%20success%2C%20emerald%20and%20teal%20accents&width=300&height=300&seq=student-5-v2&orientation=squarish'
    },
    {
      name: t('wallOfFame.students.artem') || 'Artem Bondarenko',
      subject: t('courses.english'),
      achievement: t('wallOfFame.achievements.toefl') || 'TOEFL 115 Score',
      score: 'TOEFL 115',
      image: 'https://readdy.ai/api/search-image?query=Confident%20teenage%20boy%20with%20TOEFL%20achievement%2C%20academic%20success%2C%20professional%20student%20portrait%2C%20educational%20accomplishment%2C%20bright%20background%20with%20modern%20educational%20elements&width=300&height=300&seq=student-6-v2&orientation=squarish'
    }
  ];

  const testimonials = [
    {
      name: t('wallOfFame.testimonials.maria') || 'Maria Shevchenko',
      role: t('wallOfFame.roles.mother') || 'Student\'s Mother',
      text: t('wallOfFame.testimonials.mariaText') || 'Thank you MathLish for excellent results! My daughter significantly improved her mathematics knowledge.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Happy%20mother%20testimonial%2C%20warm%20smile%2C%20professional%20portrait%2C%20satisfied%20parent%2C%20educational%20success%20story%2C%20bright%20background%20with%20modern%20elements&width=100&height=100&seq=parent-1-v2&orientation=squarish'
    },
    {
      name: t('wallOfFame.testimonials.andriy') || 'Andriy Kravchenko',
      role: t('wallOfFame.roles.student') || 'Student',
      text: t('wallOfFame.testimonials.andriyText') || 'Thanks to English lessons at MathLish, I scored 8 on IELTS! I recommend to everyone.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Happy%20male%20student%20testimonial%2C%20confident%20expression%2C%20academic%20success%2C%20professional%20portrait%2C%20educational%20achievement%2C%20bright%20modern%20background&width=100&height=100&seq=student-testimonial-1-v2&orientation=squarish'
    },
    {
      name: t('wallOfFame.testimonials.olena') || 'Olena Hrytsenko',
      role: t('wallOfFame.roles.father') || 'Student\'s Father',
      text: t('wallOfFame.testimonials.olenaText') || 'Professional approach and individual attention to each student. My son shows excellent results.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Satisfied%20father%20giving%20testimonial%2C%20professional%20appearance%2C%20happy%20parent%2C%20educational%20success%20story%2C%20warm%20expression%2C%20bright%20modern%20background&width=100&height=100&seq=parent-2-v2&orientation=squarish'
    }
  ];

  const stats = [
    { number: '1000+', label: t('wallOfFame.stats.graduates') || 'Successful Graduates' },
    { number: '95%', label: t('wallOfFame.stats.improvement') || 'Grade Improvement' },
    { number: '87%', label: t('wallOfFame.stats.university') || 'University Admission' },
    { number: '4.9/5', label: t('wallOfFame.stats.satisfaction') || 'Satisfaction Rating' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section with Motion Video Banner */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Video */}
        <div className="absolute inset-0 w-full h-full">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover object-top"
            poster="https://readdy.ai/api/search-image?query=Bright%20vibrant%20students%20celebrating%20academic%20achievements%2C%20graduation%20ceremony%20scene%20with%20diverse%20successful%20students%2C%20bright%20festive%20educational%20atmosphere%20with%20natural%20lighting%2C%20professional%20educational%20celebration%20event%20with%20emerald%20green%20and%20teal%20accents%2C%20high%20quality%20achievement%20celebration%20with%20students%20holding%20certificates%20and%20awards%2C%20inspiring%20success%20stories%20in%20modern%20educational%20setting&width=1920&height=1080&seq=wall-of-fame-hero-video-poster-v2&orientation=landscape"
          >
            <source src="https://videos.pexels.com/video-files/6238689/6238689-uhd_2560_1440_25fps.mp4" type="video/mp4" />
            <source src="https://videos.pexels.com/video-files/6238689/6238689-hd_1920_1080_25fps.mp4" type="video/mp4" />
            <source src="https://videos.pexels.com/video-files/6238689/6238689-sd_640_360_25fps.mp4" type="video/mp4" />
          </video>
          {/* Overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-br from-emerald-600/30 via-emerald-500/20 to-teal-600/30"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight drop-shadow-2xl">
              <span className="bg-gradient-to-r from-white via-yellow-100 to-white bg-clip-text text-transparent">
                {t('wallOfFame.title')}
              </span>
            </h1>
            <p className="text-xl md:text-2xl lg:text-3xl mb-12 font-medium leading-relaxed drop-shadow-xl max-w-4xl mx-auto">
              {t('wallOfFame.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
              <Button 
                size="lg" 
                className="px-12 py-6 text-xl font-bold border-2 border-white/30 rounded-xl"
                onClick={handleBookClass}
              >
                <i className="ri-calendar-check-line mr-3 text-xl"></i>
                {t('cta.bookClass')}
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center text-white">
                <div className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-br from-yellow-300 via-yellow-400 to-yellow-500 bg-clip-text text-transparent drop-shadow-lg">
                  {stat.number}
                </div>
                <div className="text-lg md:text-xl font-semibold text-white/95">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 via-white to-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-6">
              {t('wallOfFame.achievements')}
            </h2>
            <p className="text-xl text-gray-600 font-medium">
              {t('wallOfFame.achievementsSubtitle') || 'Our students achieve incredible results'}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {achievements.map((achievement, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 border-emerald-100 hover:border-emerald-200">
                <div className="text-center mb-6">
                  <img 
                    src={achievement.image}
                    alt={achievement.name}
                    className="w-24 h-24 rounded-full mx-auto mb-6 object-cover shadow-lg"
                  />
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {achievement.name}
                  </h3>
                  <span className={`inline-block px-4 py-2 rounded-full text-sm font-medium shadow-md ${
                    achievement.subject === t('courses.mathematics')
                      ? 'bg-emerald-100 text-emerald-600' 
                      : 'bg-teal-100 text-teal-600'
                  }`}>
                    {achievement.subject}
                  </span>
                </div>
                
                <div className="text-center">
                  <p className="text-gray-700 mb-4 font-medium">{achievement.achievement}</p>
                  <div className={`text-2xl font-bold ${
                    achievement.subject === t('courses.mathematics') ? 'text-emerald-600' : 'text-teal-600'
                  }`}>
                    {achievement.score}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-6">
              {t('wallOfFame.testimonials')}
            </h2>
            <p className="text-xl text-gray-600 font-medium">
              {t('wallOfFame.testimonialsSubtitle') || 'What our students and their parents say'}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-8 hover:bg-white hover:shadow-xl transition-all duration-500 transform hover:-translate-y-1 border-2 border-emerald-100 hover:border-emerald-200">
                <div className="flex items-center mb-6">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full mr-4 object-cover shadow-lg"
                  />
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg">{testimonial.name}</h4>
                    <p className="text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
                
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                
                <p className="text-gray-700 italic leading-relaxed">"{testimonial.text}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-teal-600 to-emerald-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            {t('wallOfFame.ctaTitle') || 'Become part of our Wall of Fame!'}
          </h2>
          <p className="text-xl mb-8 opacity-90">
            {t('wallOfFame.ctaSubtitle') || 'Join thousands of successful MathLish students'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-white text-teal-600 hover:bg-gray-100"
              onClick={handleBookClass}
            >
              <i className="ri-calendar-check-line mr-3"></i>
              {t('cta.bookClass')}
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-white text-white hover:bg-white hover:text-teal-600"
              onClick={() => navigate('/about')}
            >
              <i className="ri-information-line mr-3"></i>
              {t('cta.learnMore')}
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
